/**
 * Garantisce una sola preview audio attiva alla volta tra le ArtistCard.
 */
let activeId = null;
let activeStop = null;

export function claimPreviewPlayback(id, stopFn) {
  if (activeId && activeId !== id && typeof activeStop === 'function') {
    try {
      activeStop();
    } catch (_) {
      // ignore
    }
  }
  activeId = id;
  activeStop = stopFn;
}

export function releasePreviewPlayback(id) {
  if (activeId === id) {
    activeId = null;
    activeStop = null;
  }
}
